import React, { Suspense, useEffect, useState } from 'react'
import Banner from '../../components/Banner'
import PartnersLogos from '../../components/Partners'
import { useSelector } from 'react-redux'
import BlockedCountry from '../BlockedCountry'
import Loader from 'components/Loader'
import TopPerformance from 'components/TopPerformance'
import RecentGames from 'components/Lobby/RecentGames'
import { COMPONENT_NAME_MAPPING } from 'constants/uiConfig'
import AboutUs from '../../components/AboutUs'
import BenefitsStrip from 'components/BenefitsStrip'
import HomePageGames from './components/HomePageGames'
import './styles/index.scss'

const HomePage = ({ selectedFilter, setSelectedFilter }) => {
  const showBanner = useSelector(state => state?.loader?.showBanner)

  const { loading, homePage: homePageConfig, general } = useSelector(state => state.uiConfig)
  const [hasBanner, setHasBanner] = useState(true)
  const recentGames = useSelector((state) => state.casinoMenu?.recentGames)
  // Check if paymentPartnerSectionVariant is an object with variant property or a string (for backward compatibility)
  const paymentPartnerConfig = general?.paymentPartnerSectionVariant || {}
  const variantFromConfig = typeof paymentPartnerConfig === 'object' && paymentPartnerConfig.variant
    ? paymentPartnerConfig.variant
    : paymentPartnerConfig
  const isPaymentPartnerV2Variant = variantFromConfig === 'v2'

  useEffect(() => {
    if (homePageConfig) {
      const bannerComponent = homePageConfig?.components?.find((component) => component.name === COMPONENT_NAME_MAPPING.FirstFoldBanner)
      if (!bannerComponent || !bannerComponent?.isVisible || (bannerComponent.isVisible && bannerComponent.priority !== 1)) {
        setHasBanner(false)
      }
    }
  }, [loading])

  const isUserBlock = useSelector((state) => state.user?.isUserBlock)

  const getComponentToRender = (componentName) => {
    switch (componentName) {
      case COMPONENT_NAME_MAPPING.AboutSection:
        return (
          <div className='main-container-wrapper-inner'>
            <AboutUs />
          </div>
        )

      case COMPONENT_NAME_MAPPING.FirstFoldBanner:
        return (
          <section className='home-page-banner-section wrapper-content banner'>
            {showBanner && <Banner pageType='home' anchorTagFilterType='homeBannerJoinNow' setSelectedFilter={setSelectedFilter} />}
          </section>
        )

      case COMPONENT_NAME_MAPPING.PaymentPartnerSection:
        return (
          <div className='main-container-wrapper-inner'>
            <section className='partners-section fade-background'>
              <PartnersLogos
                showTitle={!isPaymentPartnerV2Variant}
                partnerType='payments'
                applyFilter={false}
                showAll={false}
                isV2Variant={isPaymentPartnerV2Variant}
              />
            </section>
          </div>
        )

      case COMPONENT_NAME_MAPPING.TopPerformanceSection:
        return (
          <div className='main-container-wrapper-inner'>
            <section className='top-performance-section'>
              <TopPerformance />
            </section>
          </div>
        )

      case COMPONENT_NAME_MAPPING.GameCarouselSection:
        return (
          <div className='bg-full-width-home-page-games'>
            <div className='main-container-wrapper-inner'>
              <section className='wrapper-content home-page'>
                <HomePageGames selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
              </section>
            </div>
          </div>
        )

      case COMPONENT_NAME_MAPPING.RecentGamesSection:
        if (recentGames !== null && !recentGames?.length) return null
        return (
          <div className='main-container-wrapper-inner'>
            <section className='wrapper-content home-page recent-games-container'>
              <RecentGames />
            </section>
          </div>
        )

      case COMPONENT_NAME_MAPPING.BenefitsStrip:
        return (
          <section className='main-container-wrapper-inner benefits-strip-section'>
            <BenefitsStrip />
          </section>
        )

      default:
        return null
    }
  }

  return (
    <>
      {loading
        ? <Loader />
        : (
          <>
            {!hasBanner && <div style={{ marginTop: '100px' }} />}
            {homePageConfig?.components?.map((component) => {
              if (!component?.isVisible) {
                return null
              }
              return getComponentToRender(component?.name)
            })}
          </>
          )}
      {isUserBlock && <Suspense fallback={<Loader top='40vh' />}><BlockedCountry showModal={isUserBlock} /></Suspense>}
    </>
  )
}

export default React.memo(HomePage)
